import {createStore} from 'vuex';
import user from '@/store/user.js';
import dict from '@/store/dict.js';

const index = {
    state:{

    },
    getters:{

    },
    mutations:{

    },
    actions:{

    },
    modules:{
        user,
        dict
    }
}

export  default createStore(index);